<template>
  <div class="font-cervo leading-none">
    <slot />
  </div>
</template>
